import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import EmailReportsList from '../../../components/reports/emails/EmailReportsList'
import EmailAgentPerformanceReport from '../../../components/reports/emails/SelectedEmailList/EmailAgentPerformanceReport'
import EmailSlaReport from '../../../components/reports/emails/SelectedEmailList/EmailSlaReport'
import EmailReport from '../../../components/reports/emails/SelectedEmailList/EmailReport'
// email report
import EmailAgentPerformanceReport1 from '../../../components/reports/emails/SelectedEmailList/EmailAgentPerformanceReport1'
import EmailSlaReport1 from '../../../components/reports/emails/SelectedEmailList/EmailSlaReport1'
import EmailReport1 from '../../../components/reports/emails/SelectedEmailList/EmailReport1'
const EmailRoute = () => {
    const tenant = localStorage.getItem('circleone-user')?.toLowerCase()
   const isMdIndia = tenant === 'mdindia' || tenant === 'stage' || tenant === 'victorinox' || tenant === 'cslfinance' || tenant === 'knabfinance' || tenant === 'mdindiadcinvoice'  || tenant === 'csquare' || tenant === 'payswiffibl' || tenant === 'payswiffstage'  || tenant === 'briezi' ;

    return (
        <Routes>
            <Route
                path='/reports-list'
                element={
                    <>
                        <EmailReportsList />
                    </>
                }
            />

            <Route
                path='/email-agent-performance-report'
                element={
                    isMdIndia ? <EmailAgentPerformanceReport /> : <EmailAgentPerformanceReport1 />
                }
            />
            <Route
                path='/email-sla-report'
                element={
                    isMdIndia ? <EmailSlaReport /> : <EmailSlaReport1 />
                }
            />
            <Route
                path='/email-report'
                element={
                    isMdIndia ? <EmailReport /> : <EmailReport1 />
                }
            />


            <Route index element={<Navigate to='/email/reports-list' />} />

        </Routes >
    )
}

export default EmailRoute
